import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import SwitchCompo from "../../component/SwitchCompo";
import { LinearProgress } from "@mui/material";
import AlertBox from "../../component/AlertBox";
import ButtonCompo from "../../component/ButtonCompo";

function RoleSettings() {
  const { userId } = useParams();
  const [adminData, setAdminData] = useState({});
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [defaultData, setDefaultData] = useState({});
  const [dataReload, setDataReload] = useState(false);

  //states for handling roles
  const [onBoardingAccess, setOnBoardingAccess] = useState(false);
  const [leaveApproval, setLeaveApproval] = useState(false);
  const [letterGenerate, setLetterGenerate] = useState(false);
  const [projectAssign, setProjectAssign] = useState(false);
  const [employeeRecordAccess, setEmployeeRecordAccess] = useState(false);
  const [employeeEditBoarding, setEmployeeEditBoarding] = useState(false);
  const [companyManagement, setCompanyManagement] = useState(false);
  const [salaryStructureCreation, setSalaryStructureCreation] = useState(false);
  const [payslipEditGenerate, setPayslipEditGenerate] = useState(false);
  const [leaveManagement, setLeaveManagement] = useState(false);
  const [notificationSend, setNotificationSend] = useState(false);
  const [eventManagement, setEventManagement] = useState(false);
  const [equipmentManagement, setEquipmentManagement] = useState(false);
  const [employeeDetailsView, setEmployeeDetailsView] = useState(false);
  const [employeeManagement, setEmployeeManagement] = useState(false);
  const [goalManagement, setGoalManagement] = useState(false);
  const [policyManagement, setPolicyManagement] = useState(false);
  const [housekeepingStaffManagement, setHousekeepingStaffManagement] =
    useState(false);
  const [talentAquisation, setTalentAquisation] = useState(false)
  const [hiringReq, setHiringReq] = useState(false)

  async function getAdmin() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/admin/get/${userId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setAdminData(res.data?.data);
      setDefaultData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }
  
  useEffect(() => {
    getAdmin();
  }, [userId]);

  //set default values
  useEffect(() => {
    setOnBoardingAccess(!!adminData.onBoardingAccess);
    setLeaveApproval(!!adminData.leaveApproval);
    setLetterGenerate(!!adminData.letterGenerate);
    setProjectAssign(!!adminData.projectAssign);
    setEmployeeRecordAccess(!!adminData.employeeRecordAccess);
    setEmployeeEditBoarding(!!adminData.employeeEditBoarding);
    setCompanyManagement(!!adminData.companyManagement);
    setSalaryStructureCreation(!!adminData.salaryStructureCreation);
    setPayslipEditGenerate(!!adminData.payslipEditGenerate);
    setLeaveManagement(!!adminData.leaveManagement);
    setNotificationSend(!!adminData.notificationSend);
    setEventManagement(!!adminData.eventManagement);
    setEquipmentManagement(!!adminData.equipmentManagement);
    setEmployeeDetailsView(!!adminData.employeeDetailsView);
    setEmployeeManagement(!!adminData.employeeManagement);
    setHousekeepingStaffManagement(!!adminData.housekeepingStaffManagement);
    setGoalManagement(!!adminData?.goalManagement)
    setPolicyManagement(!!adminData?.policyManagement)
    setTalentAquisation(!!adminData?.talentAquisation)
    setHiringReq(!!adminData?.hiringReq)
  }, [adminData, dataReload]);

  // console.log(onBoardingAccess);

  //update access api
  async function updateAccess() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/update/admin/access`,
        method: "put",
        data: {
          onBoardingAccess,
          leaveApproval,
          letterGenerate,
          projectAssign,
          employeeRecordAccess,
          employeeEditBoarding,
          companyManagement,
          salaryStructureCreation,
          payslipEditGenerate,
          leaveManagement,
          notificationSend,
          eventManagement,
          equipmentManagement,
          employeeDetailsView,
          housekeepingStaffManagement,
          employeeManagement,
          goalManagement,
          policyManagement,
          hiringReq,
          talentAquisation,
          adminId: userId,
        },
        withCredentials: true,
      });
      setOpen(true);
      setSuccess(true);
      setMessage("Access updated");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  function setAsDefault() {
    setDataReload((prev) => !prev);
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex flex-col justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] md:w-[40rem] py-5">
          <h1 className="text-[20px] font-medium text-left w-full">
            {adminData?.user?.fullName}'s Roles
            <span className="ml-2 text-[13px] font-medium text-slate-600 bg-slate-200/50 px-3 py-1 rounded-full">
              {adminData?.user?.role}
            </span>
          </h1>
          <div className="flex justify-end items-end mt-5 gap-3">
            <ButtonCompo onClick={setAsDefault}>Set As Default</ButtonCompo>
            <ButtonCompo onClick={updateAccess} variant={"contained"}>
              Save Changes
            </ButtonCompo>
          </div>
          <div className="mt-5 w-full">
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Employee Onboarding
              </p>
              <SwitchCompo
                value={onBoardingAccess}
                setValue={(e) => setOnBoardingAccess((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Leave Approval
              </p>
              <SwitchCompo
                value={leaveApproval}
                setValue={(e) => setLeaveApproval((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Letter Generate
              </p>
              <SwitchCompo
                value={letterGenerate}
                setValue={(e) => setLetterGenerate((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Project Assign
              </p>
              <SwitchCompo
                value={projectAssign}
                setValue={(e) => setProjectAssign((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Employee Record Access
              </p>
              <SwitchCompo
                value={employeeRecordAccess}
                setValue={(e) => setEmployeeRecordAccess((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Employee Edit Onboarding
              </p>
              <SwitchCompo
                value={employeeEditBoarding}
                setValue={(e) => setEmployeeEditBoarding((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Company Management
              </p>
              <SwitchCompo
                value={companyManagement}
                setValue={(e) => setCompanyManagement((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Talent Aquisation
              </p>
              <SwitchCompo
                value={talentAquisation}
                setValue={(e) => setTalentAquisation((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Hiring Request
              </p>
              <SwitchCompo
                value={hiringReq}
                setValue={(e) => setHiringReq((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Salary Structure Configurations
              </p>
              <SwitchCompo
                value={salaryStructureCreation}
                setValue={(e) => setSalaryStructureCreation((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Payslip Configurations
              </p>
              <SwitchCompo
                value={payslipEditGenerate}
                setValue={(e) => setPayslipEditGenerate((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Leave Management
              </p>
              <SwitchCompo
                value={leaveManagement}
                setValue={(e) => setLeaveManagement((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Notification Access
              </p>
              <SwitchCompo
                value={notificationSend}
                setValue={(e) => setNotificationSend((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Company Events Management
              </p>
              <SwitchCompo
                value={eventManagement}
                setValue={(e) => setEventManagement((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Employee Details Access
              </p>
              <SwitchCompo
                value={employeeDetailsView}
                setValue={(e) => setEmployeeDetailsView((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Employee Management
              </p>
              <SwitchCompo
                value={employeeManagement}
                setValue={(e) => setEmployeeManagement((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Goal Management
              </p>
              <SwitchCompo
                value={goalManagement}
                setValue={(e) => setGoalManagement((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Policy Management
              </p>
              <SwitchCompo
                value={policyManagement}
                setValue={(e) => setPolicyManagement((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                Equippment Management
              </p>
              <SwitchCompo
                value={equipmentManagement}
                setValue={(e) => setEquipmentManagement((prev) => !prev)}
              />
            </section>
            <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
              <p className="text-slate-700 text-[14px] sm:text-[16px]">
                House Keping Staff Management
              </p>
              <SwitchCompo
                value={housekeepingStaffManagement}
                setValue={(e) =>
                  setHousekeepingStaffManagement((prev) => !prev)
                }
              />
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default RoleSettings;
